import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const MIN_MAX_AGE: number = 5 * 1000;

const RESOURCE_TYPE_BOARDS_DIRECTORY = 'BOARDS_DIRECTORY';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const boardsDirectoryResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_BOARDS_DIRECTORY,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-boards-directory", jiraSpaEntry: "async-resource-boards-directory" */ './getData.tsx'
		),
	maxAge: MIN_MAX_AGE,
});
